import React from 'react';
import PropTypes from 'prop-types';
import { Card, Select } from 'modules/common';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export const ACCEPT_VALUE_OPTIONS = [
  'Donate',
  'Contribute',
  'Give',
  'Contribute Now',
  'Donate Now',
  'Give Now',
  'Submit Donation',
  "Yes, I'll Donate",
].map(value => ({ value, label: value }));

function AcceptValue({ editedUpsell, onUpdateEditedUpsell, className, subtitle }) {
  const selectedOption = ACCEPT_VALUE_OPTIONS.find(option => option.value === editedUpsell.accept) || null;

  return (
    <Row className={className}>
      <Col sm={12} md={12}>
        <Card.Title subtitle={subtitle}>Accept Button Text</Card.Title>
        <Select
          name="accept"
          label="Accept Button Text"
          isSearchable={false}
          numberOfDropdownItems={ACCEPT_VALUE_OPTIONS.length}
          disabled={editedUpsell._isDisabled}
          value={selectedOption}
          options={ACCEPT_VALUE_OPTIONS}
          onChange={onUpdateEditedUpsell}
          placeholder="Select accept button text..."
          validators={['required']}
          errorMessages={['Accept Button Text is required.']}
        />
      </Col>
    </Row>
  );
}

AcceptValue.propTypes = {
  editedUpsell: PropTypes.object.isRequired,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
  className: PropTypes.string,
  subtitle: PropTypes.string,
};

AcceptValue.defaultProps = {
  className: '',
  subtitle: 'Choose the copy for the accept upsell button.',
};

export default AcceptValue;
